import { Column } from "..";
import "./Tips.scss";

export const Tips = ({ tip1, tip2, tip3, customClass, ...otherProps }) => {
  return (
    <Column customClass={customClass ? `tips ${customClass}` : "tips"}>
      <div className="text" dangerouslySetInnerHTML={{ __html: tip1 }}></div>
      <div className="text" dangerouslySetInnerHTML={{ __html: tip2 }}></div>
      <div className="text" dangerouslySetInnerHTML={{ __html: tip3 }}></div>
    </Column>
  );
};
